/**
 * Scrolls the document to the top.
 */
export const scrollToTop = () => {
    document.documentElement.scrollTo(0, 0);
};
